module.exports = __webpack_public_path__ + "img/logo.7ba018e9.svg";